import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
    loading: true,
    collectionsList: [],
    collection: null,
    success: false,
}

const collectionsSlice = createSlice({
    name: 'collections',
    initialState,
    reducers: {
        getCollectionsList: (state, action) => {
            state.loading = true
        },
        collectionsSuccess: (state, action) => {
            state.collectionsList = action.payload
            state.loading = false
        },
        collectionsFailed: (state, action) => {
            state.loading = false
        },
        getCollection: (state, action) => {
            state.loading = true
        },
        collectionSuccess: (state, action) => {
            state.collection = action.payload
            state.loading = false
        },
        collectionFailed: (state, action) => {
            state.loading = false
            state.collection = null
        },
        recordCollection: (state, action) => {},
        collectionRecordedSuccess: (state, action) => {
            state.success = true
        },
        collectionRecordedFailed: (state, action) => {},
        resetCollection: (state, action) => {
            state.loading = false
            state.collection = null
            state.success = false
        }
    }
})

export const {
    getCollectionsList,
    collectionsSuccess,
    collectionsFailed,
    getCollection,
    collectionSuccess,
    collectionFailed,
    resetCollection,
    recordCollection,
    collectionRecordedSuccess,
    collectionRecordedFailed,
} = collectionsSlice.actions;

export default collectionsSlice.reducer;
